import type WhiteboardController from '../controllers/WhiteboardController';
import SimpleSelection from '../fabric/SimpleSelection';
import ButtonControlBase from './ButtonControlBase';

const FIELDS_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
<path d="M20 13.7143C19.974 14.3571 19.7266 14.8929 19.2578 15.3214C18.7891 15.75 18.2031 15.9762 17.5 16H2.5C1.79688 15.9762 1.21094 15.75 0.742188 15.3214C0.273438 14.8929 0.0260417 14.3571 0 13.7143V2.28571C0.0260417 1.64286 0.273438 1.10714 0.742188 0.678571C1.21094 0.25 1.79688 0.0238095 2.5 0H17.5C18.2031 0.0238095 18.7891 0.25 19.2578 0.678571C19.7266 1.10714 19.974 1.64286 20 2.28571V13.7143ZM11.25 1.71429H2.5C2.10938 1.7381 1.90104 1.92857 1.875 2.28571V13.7143C1.90104 14.0714 2.10938 14.2619 2.5 14.2857H11.25V1.71429ZM17.5 3.14286C17.4479 2.61905 17.1354 2.33333 16.5625 2.28571H14.6875C14.1146 2.33333 13.8021 2.61905 13.75 3.14286C13.8021 3.66667 14.1146 3.95238 14.6875 4H16.5625C17.1354 3.95238 17.4479 3.66667 17.5 3.14286ZM14.6875 5.71429C14.1146 5.7619 13.8021 6.04762 13.75 6.57143C13.8021 7.09524 14.1146 7.38095 14.6875 7.42857H16.5625C17.1354 7.38095 17.4479 7.09524 17.5 6.57143C17.4479 6.04762 17.1354 5.7619 16.5625 5.71429H14.6875ZM17.5 10C17.4479 9.47619 17.1354 9.19048 16.5625 9.14286H14.6875C14.1146 9.19048 13.8021 9.47619 13.75 10C13.8021 10.5238 14.1146 10.8095 14.6875 10.8571H16.5625C17.1354 10.8095 17.4479 10.5238 17.5 10Z" fill="#999999"/>
</svg>`;

class FieldsControl extends ButtonControlBase {
  offsetX = 20;
  offsetY = 20;

  static icon = ButtonControlBase.prepareIcon(FIELDS_ICON);

  mouseUpHandler(eventData: MouseEvent, transform: fabric.Transform): boolean {
    const { target } = transform;
    let controller: WhiteboardController;

    if (target instanceof SimpleSelection) {
      controller = target.canvas.controller;
    } else {
      controller = target.controller;
    }

    controller.actionShowDrawerPath(`/selection`);

    return false;
  }
}

export default FieldsControl;
